import { render, staticRenderFns } from "./ScreenReviews.vue?vue&type=template&id=65909767&lang=pug"
import script from "./ScreenReviews.vue?vue&type=script&lang=ts"
export * from "./ScreenReviews.vue?vue&type=script&lang=ts"
import style0 from "./ScreenReviews.vue?vue&type=style&index=0&id=65909767&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports